import { getFromLocalStorage, saveToLocalStorage } from '@/utils/storage';
import { isSubString } from '@/utils/strings';
import { STORE_CONST } from '@/constants';
import BTB_CONF from '@/btb-conf.json';

// TODO: make sure storagePrefix has user scorm ID
export const SaveUserConf = (store: any) => {
  var moduleName = STORE_CONST.USER_CONF_MODULE_NAME;
  var alreadyRestored = false;

  //called on every store change
  store.subscribe((mutation: any, state: any) => {
    if (
      isSubString(moduleName, mutation.type) ||
      mutation.type === 'SET_USER_ID'
    ) {
      restoreIfNeeded(store.getters.storagePrefix);
      // only saves chagnes related to the model
      saveToLocalStorage(store.getters.storagePrefix, state.userConf);
    }
  });

  function restoreIfNeeded(storagePrefix: string) {
    if (!alreadyRestored) {
      alreadyRestored = true;
      if (getFromLocalStorage(storagePrefix)) {
        // it just reassings the value of the userConfStore
        restoreFromLocalStorage(store.state.userConf, storagePrefix);
      }
    }
  }

};

export function restoreFromLocalStorage(userConfState: any, stPrefix: string) {
  let userConf = getFromLocalStorage(stPrefix);
  Object.assign(userConfState, userConf);
}